import { render, staticRenderFns } from "./ResponsibilitiesComponent.vue?vue&type=template&id=21d33c7b"
import script from "./ResponsibilitiesComponent.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports